import { useRef, useEffect, useState } from 'react';
import cn from 'classnames';

import useSlider from 'js/hooks/use-slider';
import useResize from 'js/hooks/use-resize';

interface IPlayerTimeline {
  progress: number;
  setTime: (time: number) => void;
  className?: string;
}

const PlayerTimeline: React.FC<IPlayerTimeline> = ({ progress, setTime, className }) => {
  const [, forceUpdate] = useState(0);
  useResize(() => forceUpdate(prev => prev + 1));

  const timelineRef = useRef<HTMLDivElement>(null);
  const { value, activate, activateKeys, deactivateKeys, isActive } = useSlider(timelineRef);

  const progressInPxs = timelineRef.current && progress * (timelineRef.current.offsetWidth || 0);

  useEffect(() => {
    if (!value) return;
    setTime(value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  // setTime is a prop callback - adding causes re-renders

  return (
    <div
      className={cn('player-timeline', className)}
      onFocus={activateKeys}
      onBlur={deactivateKeys}
      onTouchStart={activate}
      onMouseDown={activate}
      tabIndex={0}
    >
      <div className="player-timeline--track" ref={timelineRef}>
        <span
          className="player-timeline--marker"
          style={{
            transform: `translateX(${progressInPxs}px)`,
            transition: !isActive ? 'transform 0.2s linear' : 'none'
          }}
        ></span>
      </div>
    </div>
  );
};

PlayerTimeline.displayName = 'PlayerTimeline';

export default PlayerTimeline;
